export default __webpack_public_path__ + "static/media/banner-coffee.772e75c3.png";